import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import type { ModelProductSupplier } from '@app/api/Products';
import type { GetColumnType } from '@app/pages/Warehouses/Suppliers/types';

import type { ColumnsType } from 'antd/es/table';

export const getSuppliersColumns: GetColumnType = ({
  onEdit,
  IsSupplierEdit,
}) => {
  const columns: ColumnsType<ModelProductSupplier> = [
    {
      title: 'Название',
      dataIndex: 'Name',
      key: 'Name',
      ellipsis: true,
      width: 220,
      render: (text) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Телефон',
      dataIndex: 'Phone',
      key: 'Phone',
      width: 180,
      render: (phone) => <span>+{phone}</span>,
    },
    {
      title: 'Примечание',
      dataIndex: 'Comment',
      key: 'Comment',
      ellipsis: true,
      width: 200,
      render: (text) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {text}
        </span>
      ),
    },
    {
      title: null,
      key: 'actions',
      width: 48,
      fixed: 'right',
      render: (_: unknown, row: ModelProductSupplier) =>
        IsSupplierEdit ? (
          <Button icon={<EditOutlined />} onClick={() => onEdit(row?.Id)} />
        ) : (
          <></>
        ),
    },
  ];

  return columns;
};
